import React from 'react';
import { Section, preloader } from 'spectacle-ppa';
import { i18nData } from 'helpers/i18n';

import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';
import headingSlide from '../../baseSlides/headingSlide';

import imagePPALogo from '../../images/logo_ppa.png';
import esGooberGoofySmile from '../../images/characters/esmeralda_goober_goofy_smile.png';
import ianSaraSilly from '../../images/characters/ian_sara_silly.png';
import esGooberProud from '../../images/characters/esmeralda_goober_proud.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile_en from './ending.md';
import markdownFile_fr_CA from './ending.fr_CA.md';

const md = i18nData({
  en: new MarkdownScript(markdownFile_en),
  fr_CA: new MarkdownScript(markdownFile_fr_CA)
});

export function preloadEnding() {
  preloader([
    esGooberGoofySmile,
    ianSaraSilly,
    esGooberProud,
    imagePPALogo
  ]);
}

function endingSection({ regionData, i18n }) {
  const md_i18n = i18n(md);
  return (
    <Section id="ending">

      {/* Time to see who won! */}
      {balloonSlide({
        id: 'announce-winners',
        characterSide: 'right',
        characterImage: ianSaraSilly,
        html: md_i18n.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
        notes: md_i18n.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
      })}

      {/* Ian & Sara pie */}
      {videoSlide({
        id: 'ian-sara-pie',
        notes: md_i18n.getSubSectionAsHtml('Ian and Sara Pie', 'Notes', false, regionData),
        youTubeId: md_i18n.getSectionMetadata('Ian and Sara Pie', 'YouTube', regionData)
      })}

      {/* Esmeralda and Goober Congrats */}
      {videoSlide({
        id: 'congrats-video',
        notes: md_i18n.getSubSectionAsHtml('Esmeralda and Goober Congrats', 'Notes', false, regionData),
        youTubeId: md_i18n.getSectionMetadata('Esmeralda and Goober Congrats', 'YouTube', regionData)
      })}

      {/* You've completed all the levels */}
      {headingSlide({
        id: 'completed',
        beforeImage: imagePPALogo,
        heading: i18n('Keep Cool') + '!',
        subHeading: i18n('All levels completed') + '!!!',
        notes: md_i18n.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
        bgColor: 'black'
      })}

    </Section>
  );
}

export default endingSection;



// WEBPACK FOOTER //
// ./programs/keepCool/sections/95_ending/endingSection.jsx